import {Component, OnInit} from '@angular/core';
import {ChartsService} from '../../services/charts.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GetAverageScoreAccumulatorResponseDto} from '../../models/GetAverageScoreAccumulatorResponseDto';
import {DatePickerModeEnum} from '../../models/DatePickerModeEnum';
import * as moment from 'moment';
import {AverageScoreAccumulatorsService} from '../../services/average-score-accumulators.service';
import {GetSitePageResponseDto} from '../../models/GetSitePageResponseDto';
import {GetSiteResponseDto} from '../../models/GetSiteResponseDto';
import {SitePageChartDataModel} from '../../models/SitePageChartDataModel';
import {SitePagesService} from '../../services/site-pages.service';
import {SitesService} from '../../services/sites.service';
import {BaseAfterViewInitComponent} from '../base-components/after-view-init/base-after-view-init.component';
import {GetCustomerResponseDto} from '../../models/GetCustomerResponseDto';
import {CustomersService} from '../../services/customers.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.css']
})
export class PageComponent extends BaseAfterViewInitComponent implements OnInit {

    page: GetSitePageResponseDto;
    site: GetSiteResponseDto;
    customer: GetCustomerResponseDto;
    sitePagesChartData: Array<SitePageChartDataModel>;
    selectedAverageScoreAccumulator: GetAverageScoreAccumulatorResponseDto;
    selectedDate: moment.Moment = null;
    DatePickerModeEnum = DatePickerModeEnum;
    childrenInitialized = false;

    constructor(
        private chartsService: ChartsService,
        private route: ActivatedRoute,
        private sitePagesService: SitePagesService,
        private sitesService: SitesService,
        private customerService: CustomersService,
        private averageScoreAccumulatorsService: AverageScoreAccumulatorsService,
        private translateService: TranslateService,
        private router: Router) {
        super();
        this.route.params.subscribe(params => {
            this.sitePagesService.getById(params.id).subscribe(response => {
                this.page = response.body;
                this.sitesService.getById(this.page.siteId);
                this.sitesService.getOnSiteLoadedSubject().subscribe(
                    site => {
                        this.site = site;
                        this.customerService.getByCrmId(this.site.crmId)
                            .subscribe(response => this.customer = response.body);
                    });
            });
            this.chartsService.getPageReviewScoresChartData(params.id, 3, moment().format('YYYY-MM-DD')).subscribe(response => {
                this.sitePagesChartData = response.body.reverse();
            });
        });

    }

    ngOnInit() {
        this.averageScoreAccumulatorsService.getAverageScoreAccumulatorsLoadedSubject().subscribe(data => {
            this.selectedAverageScoreAccumulator = data[2];
        });
    }

    onDateSelected(date: moment.Moment) {
        this.selectedDate = date;
        if (this.childrenInitialized) {
            this.getPageReviewScoresChartData();
        }
    }

    onAverageScoreAccumulatorSelected(averageScoreAccumulator: GetAverageScoreAccumulatorResponseDto) {
        this.selectedAverageScoreAccumulator = averageScoreAccumulator;
        this.selectedDate = this.selectedDate || moment();
        this.getPageReviewScoresChartData();
    }

    navigateToSiteComponent() {
        const path = '/site/' + this.site.id;
        const fullPath = this.translateService.currentLang !== undefined ? this.translateService.currentLang + path : path;
        this.router.navigate([fullPath]);
    }

    private getPageReviewScoresChartData() {
        this.chartsService.getPageReviewScoresChartData(
            this.page.id,
            this.selectedAverageScoreAccumulator.id,
            this.selectedDate.format('YYYY-MM-DD')
        ).subscribe(response => {
            this.sitePagesChartData = response.body.reverse();
        });
    }

}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/page/page.component.ts